import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading2, Heading3, Text } from '@blueprint/ui';
import { ArrowDownSmall, ArrowUpSmall } from '@blueprint/icons';

export const StyledHeading2 = styled(Heading2)(
    ({ theme: { spacing } }) => css`
        margin-bottom: ${spacing['24px']};
    `
);

export const StatsSection = styled('section')(
    ({ theme: { spacing } }) => css`
        margin-bottom: ${spacing['32px']};
    `
);

export const RecentSalesSection = styled('section')(
    ({ theme: { spacing } }) => css`
        margin-bottom: ${spacing['16px']};

        ${Heading3} {
            margin-bottom: 0;
        }
    `
);

export const RentalOpportunitiesSection = styled('section')(
    ({ theme: { mq, spacing } }) => css`
        margin-bottom: ${spacing['32px']};

        ${mq.small} {
            p {
                max-width: 80%;
            }
        }

        span {
            display: block;

            &:last-of-type {
                margin-top: ${spacing['8px']};
            }
        }
    `
);

export const StatsList = styled('ul')(({ theme: { mq, spacing } }) => {
    const itemSpacingHorizontal = spacing['24px'];
    const itemSpacingVertical = spacing['16px'];

    return css`
        display: flex;
        flex-wrap: wrap;
        margin: 0;
        padding: 0;
        list-style: none;
        margin-top: ${spacing['16px']};

        li {
            margin: 0;
            padding: 0;

            &:first-of-type {
                width: 100%;
                flex-grow: 1;
                padding-bottom: ${itemSpacingVertical};
            }

            &:last-of-type {
                padding-left: ${itemSpacingHorizontal};
            }
        }

        ${mq.medium} {
            flex-wrap: nowrap;

            li {
                padding: 0 0 0 ${itemSpacingHorizontal};
                &:first-of-type {
                    width: initial;
                    padding: 0;
                }
            }
        }
    `;
});

export const StatName = styled(Text)(
    ({ theme: { spacing } }) => css`
        margin-bottom: ${spacing['4px']};
    `
);

export const StatValues = styled(Text)(
    ({ theme: { spacing } }) => css`
        display: flex;
        align-items: center;

        ${IconIncrease}, ${IconDecrease} {
            margin: 0 ${spacing['8px']};
        }
    `
);

export const IconIncrease = styled(ArrowUpSmall)(
    ({ theme: { colors } }) => css`
        color: ${colors['function-success']};
    `
);

export const IconDecrease = styled(ArrowDownSmall)(
    ({ theme: { colors } }) => css`
        color: ${colors['function-error']};
    `
);
